class EventService {
    /**
     * See https://support.google.com/analytics/answer/1033068#Anatomy
     * @param eventCategory
     *      Name for grouping objects which we track
     * @param eventAction
     *      Name for the type of action which we wish to track
     * @param eventLabel
     *      Optional. Can be used to more closely identify an action (E.g. Viewed Account -> which account?)
     */
    public track(eventCategory: string, eventAction: string, eventLabel?: string) {
        try {
            if ((window as any).ga) {
                let fieldsObject = {
                    hitType: 'event',
                    eventCategory,
                    eventAction,
                    eventLabel
                };
                if (eventLabel) {
                    fieldsObject.eventLabel = eventLabel;
                }
                (window as any).ga('send', fieldsObject);
            }
        } catch (err) {
            // swallow
        }
    }
}

export const eventService = new EventService();
